import React from 'react';
import classes from './ProjectListItem.module.scss';
import {Card, CardBody, CardFooter, CardSubtitle, CardText, CardTitle, Row} from 'reactstrap';
import ProgressBar from "../../../components/UI/ProgressBar/ProgressBar";
import Badge from '../../../components/UI/Badges/Badge';

const projectListItem = (props) => {
    const {achievements} = props;

    return (
        <div className={`h-100`} key={props._id}
             aria-hidden={props['aria-hidden']}>
            <Card className="h-100 anl__project-list--item">
                <div className={classes.CardImageContainer}>
                    <div className={classes.CardImage} style={{backgroundImage: `url(${props.image})`}}
                         aria-hidden={true}/>
                </div>
                <CardBody className="d-flex flex-column">
                    <CardTitle tag="h2">{props.name}</CardTitle>
                    <CardSubtitle tag="h6" className="mb-2 text-muted">{props.title}</CardSubtitle>
                    <CardText className="text-body">{props.shortDescription}</CardText>
                    <ProgressBar
                        bubble={false}
                        projectBalance={props.projectBalance}
                        voteCount={props.voteCount}
                        phases={props.phases}
                        cssClasses={'mt-auto'}
                        fundingStages={props.fundingStages}

                    />
                    {props.children}
                </CardBody>
                <CardFooter className={`p-0 ${classes.CardFooter}`}>
                    <Row className="m-0 top-0 justify-content-end">
                        <Badge type="isReferral" isAchieved={achievements.some(ach => ach.type === 'isReferral' && ach.isAchieved)} />
                        <Badge type="hasReferred" isAchieved={achievements.some(ach => ach.type === 'hasReferred' && ach.isAchieved)} />
                        <Badge type="emailShares" isAchieved={achievements.some(ach => ach.type === 'emailShares' && ach.isAchieved)} />
                        <Badge type="twitterShares" isAchieved={achievements.some(ach => ach.type === 'twitterShares' && ach.isAchieved)} />
                        <Badge type="facebookShares" isAchieved={achievements.some(ach => ach.type === 'facebookShares' && ach.isAchieved)} />
                        <Badge type="whatsAppShares" isAchieved={achievements.some(ach => ach.type === 'whatsAppShares' && ach.isAchieved)} />
                        {/* Add more BadgeComponent instances as needed for other badge types */}
                    </Row>
                </CardFooter>
            </Card>
        </div>
    );
};

export default projectListItem;
